import { AutoComplete, Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { AccountGroupService } from "../../services/group/AccountGroupService";
import { handleError } from "../../utils/ErrorHandlers";
import GroupAccountsList from "../groupAccounts/GroupAccountsList";
import Page from "../general/Page";
import "./GroupAccounts.css";
import { Translation } from "react-i18next";
import i18next from "i18next";
class GroupAccounts extends Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("groups");
    this.state = {
      isFetching: false,
    };
  }

  componentDidMount() {
    this.getAllGroupAccountsService();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }
  async getAllGroupAccountsService() {
    let accountId = this.props.context.user.accountId;

    try {
      this.acc = new AccountGroupService();
      this.setState({ isFetching: true });
      let data = await this.acc.getAccountGroups(this.props.context.session_id);
      this.groupDataAndCfgMapping(data.ivrList, data.cfgList);
      // this.setState({
      //   data: data.ivrList,
      //   isFetching: false,
      //   cfgData: data.cfgList,
      // });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }
  cfgFormatting(cfgfiltered, grpType) {
    // change the formatting of property
    let cfgFormatted = {};
    if (grpType === "SXG") {
      cfgfiltered.forEach((el, index) => {
        if (el.key === "SWITCH_MODE") {
          cfgFormatted.switch_mode = el.value;
          cfgFormatted.accountId = el.accountId;
          cfgFormatted.configCategory = el.configCategory;
          cfgFormatted.groupId = el.groupId;
        } else if (el.key === "MAX_CONCURRENT_CALLS") {
          cfgFormatted.max_concurrent_calls = el.value;
          cfgFormatted.accountId = el.accountId;
          cfgFormatted.configCategory = el.configCategory;
          cfgFormatted.groupId = el.groupId;
        }
      });
    } else {
      cfgfiltered.forEach((el, index) => {
        if (el.key === "MAX_CONCURRENT_CALLS") {
          cfgFormatted.max_concurrent_calls = el.value;
          cfgFormatted.accountId = el.accountId;
          cfgFormatted.configCategory = el.configCategory;
          cfgFormatted.groupId = el.groupId;
        } else if (el.key === "GROUP_NUMBERS") {
          cfgFormatted.group_numbers = el.value.split(",");
          cfgFormatted.accountId = el.accountId;
          cfgFormatted.configCategory = el.configCategory;
          cfgFormatted.groupId = el.groupId;
        } else if (el.key === "CALL_FLOW") {
          cfgFormatted.call_flows = el.value;
          cfgFormatted.accountId = el.accountId;
          cfgFormatted.configCategory = el.configCategory;
          cfgFormatted.groupId = el.groupId;
        } else if (el.key === "READY_FLOW") {
          cfgFormatted.ready_flow = el.value;
          cfgFormatted.accountId = el.accountId;
          cfgFormatted.configCategory = el.configCategory;
          cfgFormatted.groupId = el.groupId;
        } else if (el.key === "ACTIVATE_VOICEMAIL") {
          cfgFormatted.activate_voicemail = el.value;
          cfgFormatted.accountId = el.accountId;
          cfgFormatted.configCategory = el.configCategory;
          cfgFormatted.groupId = el.groupId;
        } else if (el.key === "START_WORKING_HOUR") {
          cfgFormatted.start_hour = el.value;
          cfgFormatted.accountId = el.accountId;
          cfgFormatted.configCategory = el.configCategory;
          cfgFormatted.groupId = el.groupId;
        } else if (el.key === "END_WORKING_HOUR") {
          cfgFormatted.end_hour = el.value;
          cfgFormatted.accountId = el.accountId;
          cfgFormatted.configCategory = el.configCategory;
          cfgFormatted.groupId = el.groupId;
        } else if (el.key === "VOICEMAIL_PROMPT") {
          cfgFormatted.voicemail_message = el.value;
          cfgFormatted.accountId = el.accountId;
          cfgFormatted.configCategory = el.configCategory;
          cfgFormatted.groupId = el.groupId;
        } else if (el.key === "WORKING_DAYS") {
          cfgFormatted.working_days = el.value;
          cfgFormatted.accountId = el.accountId;
          cfgFormatted.configCategory = el.configCategory;
          cfgFormatted.groupId = el.groupId;
        }
      });
    }

    return cfgFormatted;
  }

  groupDataAndCfgMapping(data, cfgData) {
    //let { data, cfgData } = this.state;
    //get an array of data and cfg
    data.forEach((element, index) => {
      let cfgtest = cfgData.filter(
        (cfgEl) =>
          element.accountId === cfgEl.accountId &&
          element.groupId === cfgEl.groupId
      );

      data[index].cfg = this.cfgFormatting(cfgtest, element.groupType);
    });

    this.setState({ data: data, isFetching: false });
  }

  showCreateGroupAccountForm = () => {
    let { history } = this.props;
    history.push(`/home/groups/create/`);
  };

  handleOk = (e) => {
    e.preventDefault();
    let { history } = this.props;

    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          this.setState({ loading: true });
          await this.createGroupAccount(values);
          this.setState({
            visible: false,
          });
          this.setState({ loading: false });
          this.props.form.resetFields();
          this.getAllGroupAccountsService();
        }
      } catch (e) {
        this.setState({ loading: false, visible: false });
        handleError(e);
      }
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };
  render() {
    let data = this.state.data;
    let { isFetching } = this.state;

    return (
      <Translation>
        {(t) => (
          <Page title={t("Groups")}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                {/* <Button
              className="button-add-account"
              onClick={this.showCreateGroupAccountForm}
              icon="plus"
            />
            <span>Add Group</span> */}

                <GroupAccountsList
                  data={this.state.data}
                  onRefresh={() => this.getAllGroupAccountsService()}
                ></GroupAccountsList>
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(GroupAccounts))
);
